import Upgrade from "../Upgrade";
import UpgradeCollection from "../UpgradeCollection";

export default class MinedUpgradeCollection extends UpgradeCollection {
    constructor() {
        super();

        /**
         * @constant
         * @type {number}
         */
        this.combineUpgradeThreshold = 8;

    }

    /**
     * @param {string} creatorId 
     * @returns {boolean}
     */
    contains(creatorId) {
        for (let i = 0; i < this.upgrades.length; i++) {
            const upgrade = this.upgrades[i];
            if (upgrade.getCreatorId() === creatorId) {
                return true;
            }
        }

        return false;
    }

    /**
     * @param {Upgrade} upgrade 
     */
    add(upgrade) {
        super.add(upgrade);

        if (this.upgrades.length > this.combineUpgradeThreshold) {
            this.combineUpgrades();
        }
    }

    /**
     * @private
     */
    combineUpgrades() {
        for (let i = 0; i < this.upgrades.length - 1; i++) {
            const upgrade1 = this.upgrades[i];
            if (!upgrade1.isCombineSupported()) {
                continue;
            }

            for (let j = this.upgrades.length - 1; j > i; j--) {
                const upgrade2 = this.upgrades[j];
                if (!upgrade2.isCombineSupported()) {
                    continue;
                }

                if (upgrade1.getCreatorId() !== upgrade2.getCreatorId()) {
                    continue;
                }

                // if (!upgrade1.isCombineCandidate(upgrade2)) {
                //     continue;
                // }

                upgrade1.upgradeCreator.combineUpgrades(upgrade1, upgrade2);

                // Remove upgrade2
                this.upgrades.splice(j, 1);
                this.changeCount++;
                
                break;
            }
        }
    }
}